import styled from "styled-components";
import { Link } from 'react-router-dom';
import { useGlobalContext } from "../context";
import { useState } from "react";
import Navbar from "./Navbar";
import { RiMenu5Line } from "react-icons/ri";
import en from '../images/en.png';
import it from '../images/it.png';
import logo from '../images/logo.png';

const Header = () => {

  const { language, changeLanguage } = useGlobalContext(); 
  const [active, setActive] = useState(false);

  return <Wrapper>
            <div className="container">
                <button className="flag" onClick={changeLanguage}>
                    {language === 'en' ? <img src={it} alt="" /> : <img src={en} alt="" />}
                </button>
                
                <Link to='/' className="link logo">
                    <img src={logo} alt="" />
                </Link>
                
                <div></div>
                
                <button className="hamburger" onClick={() => setActive(!active)}>
                    <RiMenu5Line className="icon" />
                </button>
                <Navbar active={active} setActive={setActive} />    
            </div>        
    </Wrapper>
}

export default Header;

const Wrapper = styled.header`
        position: fixed;
        width: 100%;
        z-index: 10;
        background-color: white;
        height: 75px;
        .container {
            position: relative;
            height: 100%;
            padding: 0px 4px;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
        .logo img {
            display: block;
            width: 50px;
            height: 50px;
            cursor: pointer;
            margin-right: 25px;
        }
        .flag {
            border-style: none;
            display: flex;
            justify-content: center;
            align-items: center;
            background-color: white;
            img {
                cursor: pointer;
                object-fit: cover;
                object-position: center;
                width: 25px;
                height: 25px;
            }
        }
        .hamburger {
            border-style: none;
            position: absolute;
            right: 4px;
            z-index: 10;
            .icon {
                background-color: white;
                color: var(--logo);
                cursor: pointer;
                font-size: 25px;
                display: flex;
                justify-content: center;
                align-items: center;
            }
        }
`;